export default "<div class=\"SkinSpacer\">&nbsp;</div>\n<div class=\"SkinBody\"><router-outlet></router-outlet></div>"